import { EnvironmentInterface } from './environment.interface';

const apiUri = '//api-dev.returnon.college';

export const environment: EnvironmentInterface = {
  environmentName: 'DEV',
  production: false,
  graphql: `${apiUri}/graphql`,
  occupationGraphql: 'https://dev-api.datastop.io/occupations/graphql',
  rocCalculatorApi: 'https://api-dev-roc-calculator.returnon.college/roc-calculator',
  widgetParentOrigin: [
    'http://localhost:4201',
    'http://localhost:4200',
    'https://dev.xp4.careers',
    'https://sva-dev.xp4.careers',
    'https://staging.careerpathdecide.org',
    'https://dev.careerpathdecide.org'
  ]
};
